import React from 'react';
import { getImageUrl } from '../../config/apiConfig';
import { Play } from 'lucide-react';

function CourseThumbnailSection({ course, onClick }) {
  const displayThumbnail = course?.thumbnail ? getImageUrl(course.thumbnail) : '/default_course.png';

  const handleImageError = (e) => {
    if (e.target.src.includes('/default_course.png')) return;
    e.target.onerror = null;
    e.target.src = '/default_course.png';
  };

  return (
    <div onClick={() => onClick && onClick(course)} className="relative h-52 bg-gray-200 cursor-pointer overflow-hidden">
      <img
        src={displayThumbnail}
        alt={course?.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        onError={handleImageError}
      />

      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
        <div className="w-16 h-16 bg-white/90 text-primary-600 rounded-full flex items-center justify-center transform scale-0 group-hover:scale-100 transition-all duration-300 shadow-xl">
          <Play size={28} fill="currentColor" className="ml-1" />
        </div>
      </div>

      <div className="absolute top-4 left-4">
        <span className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-xl text-[10px] font-black shadow-lg backdrop-blur-md ${
          course?.is_active !== false ? 'bg-green-500/90 text-white' : 'bg-gray-800/90 text-white'
        }`}>
          {course?.is_active !== false ? 'نشط' : 'مسودة'}
        </span>
      </div>
    </div>
  );
}

export default CourseThumbnailSection;
